export default "__VITE_ASSET__O0Ct84KQ__"